var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InfoTooltip',{staticClass:"tool-icon-wrapper",attrs:{"show-icon":false,"text":_vm.helpText}},[_c('Panel',_vm._g({staticClass:"cursor-pointer",class:[
      _vm.hasPaddings ? 'p-3' : 'p-0',
      {
        disabled: _vm.disabled,
      } ],attrs:{"variant":_vm.displayVariant}},_vm.$listeners),[_c('Icon',{attrs:{"name":_vm.iconName,"width":_vm.iconWidth,"fill":_vm.iconFill,"rotate":_vm.iconRotate}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }